import { render, staticRenderFns } from "./LeadHistoryStatuses.vue?vue&type=template&id=96dcfbd4&scoped=true"
import script from "./LeadHistoryStatuses.vue?vue&type=script&lang=js"
export * from "./LeadHistoryStatuses.vue?vue&type=script&lang=js"
import style0 from "./LeadHistoryStatuses.vue?vue&type=style&index=0&id=96dcfbd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96dcfbd4",
  null
  
)

export default component.exports